export enum MODAL_NAME {
  planChange = 'Change plan confirmation',
  churnSurvey = 'Change plan confirmation with churn Survey',
  multiSkuChurnSurvey = 'Change plan confirmation with multi sku churn Survey',
  churnDeflection = 'Change plan confirmation churn deflection',
  multiSkuChurnDeflection = 'Change plan confirmation multi sku churn deflection',
  summaryOfChanges = 'Summary of Changes',
}
